import Role from './role';

export default class Roles {

  static readonly sysAdmin = [
    Role.sysAdmin,
  ];

  static readonly bizAdmin = [
    Role.bizAdmin,
  ];

  static readonly adminOnly = [
    Role.admin
  ];

  static readonly admin = [
    Role.admin,
    Role.cdAdmin,
    Role.adminViewer,
    Role.adminSelect,
  ];

  static readonly cdAdmin = [
    Role.cdAdmin,
  ];

  static readonly adminSelect = [
    Role.adminSelect,
  ];

  static readonly switchView = [
    Role.admin,
    Role.agent
  ]

  static readonly dealerNewView = [
    Role.admin,
    Role.agent,
    Role.sysAdmin,
    Role.bizAdmin,
    Role.b2bPartner,
  ]

  static readonly dealerSupport = [
    Role.bizAdmin,
    Role.admin,
    Role.adminViewer,
    Role.dealerAgent,
    Role.dealer,
    Role.dealerManager,
  ];

  static readonly dealer = [
    Role.dealer,
    Role.secaDealerStaff,
    Role.seaImDealerStaff,
    Role.seaImDealerSuperVisor,
    Role.secaDealerSuperVisor,
  ];

  static readonly dealerSupervisor = [
    Role.seaImDealerSuperVisor,
    Role.secaDealerSuperVisor,
  ];

  static readonly agent = [
    Role.agent,
  ];

  static readonly dealerAgent = [
    Role.dealerAgent,
  ];

  static readonly cdSupport = [
    Role.bizAdmin,
    Role.admin,
    Role.adminViewer,
    Role.concealedDamageAgent,
    Role.concealedDamageStore,
    Role.ussi,
    Role.ussiAdmin,
    Role.be,
    Role.ra,
    Role.beAdmin,
    Role.raAdmin,
    Role.cdAdmin,
  ];

  static readonly cdStore = [
    Role.concealedDamageStore,
    Role.dealer,
  ];

  static readonly cdCreator = [
    Role.concealedDamageStore,
    Role.dealer,
    Role.ussi,
    Role.be,
    Role.ra,
  ];

  static readonly cdReviewer = [
    Role.agent,
    Role.cdAdmin
  ];

  static readonly summaryView = [
    Role.bizAdmin,
    Role.admin,
    Role.adminViewer,
    Role.dealer,
    Role.dealerAgent,
    Role.secaDealerStaff,
    Role.seaImDealerStaff,
    Role.secaDealerSuperVisor,
    Role.seaImDealerSuperVisor,
    Role.adminSelect,
    Role.dealerManager,
  ];

  static readonly ussi = [
    Role.ussi,
    Role.ussiAdmin,
    Role.be,
    Role.beAdmin,
    Role.ra,
    Role.raAdmin,
  ];

  static readonly ussiAdmin = [
    Role.ussiAdmin,
    Role.beAdmin,
    Role.raAdmin,
  ];

  static readonly cdAgent = [
    Role.concealedDamageAgent,
  ];

  // SECA
  static readonly secaTicket = [
    Role.secaAdmin,
    Role.secaAgent,
    Role.secaDealerSuperVisor,
    Role.secaDealerStaff,
  ]

  static readonly secaUser = [
    Role.secaAdmin,
    Role.secaDealerSuperVisor,
    Role.secaDealerStaff,
  ]

  static readonly secaDealer = [
    Role.secaAdmin,
    Role.secaDealerSuperVisor,
  ]

  static readonly secaSummary = [
    Role.secaAdmin,
    Role.secaAgent,
    Role.secaDealerSuperVisor,
    Role.secaDealerStaff,
  ]

  // SEA_IM
  static readonly seaImTicket = [
    Role.seaImAdmin,
    Role.seaImAgent,
    Role.seaImDealerSuperVisor,
    Role.seaImDealerStaff,
  ]

  static readonly seaImUser = [
    Role.seaImAdmin,
    Role.seaImDealerSuperVisor,
    Role.seaImDealerStaff,
  ]

  static readonly seaImDealer = [
    Role.seaImAdmin,
    Role.seaImDealerSuperVisor,
  ]

  static readonly seaImSummary = [
    Role.seaImAdmin,
    Role.seaImAgent,
    Role.seaImDealerSuperVisor,
    Role.seaImDealerStaff,
  ]

  static readonly b2bUser = [
    Role.admin,
    Role.b2bCustomer,
    Role.b2bCustomerAdmin,
    Role.b2bPartner,
    Role.b2bPartnerAdmin,
    Role.b2bRsmAdmin,
  ]

  static readonly b2bCustomer = [
    Role.b2bCustomer,
  ]

  static readonly b2bCustomerAdmin = [
    Role.b2bCustomerAdmin,
  ]

  static readonly b2bCustomerAndAdmin = [
    Role.b2bCustomerAdmin,
    Role.b2bCustomer,
  ]

  static readonly b2bAdmin = [
    Role.admin,
    Role.b2bPartner,
    Role.b2bPartnerAdmin,
    Role.b2bRsmAdmin,
  ]

  static readonly b2bRsm = [
    Role.admin,
    Role.b2bPartner,
    Role.b2bPartnerAdmin,
    Role.b2bSvcVendor,
    Role.b2bRsmAdmin,
  ]


  static readonly b2bAdminAndCustomer = [
    Role.b2bCustomerAdmin,
    Role.b2bCustomer,
    Role.admin,
    Role.b2bPartner,
    Role.b2bPartnerAdmin,
    Role.b2bRsmAdmin,
  ]

  static readonly b2bRsmAdmin = [
    Role.b2bRsmAdmin,
  ]

  static readonly b2bPartnerRsm = [
    Role.b2bSvcVendor,
  ]

  static readonly b2bUserAdmin = [
    Role.admin,
    Role.b2bCustomerAdmin
  ]

  static readonly b2bAdminOnly = [
    Role.admin,
  ]

  static readonly b2bPartnerAdmin = [
    Role.b2bPartnerAdmin,
  ]

  static readonly readonlyRoles = [
    Role.b2bPartnerAdmin,
    Role.b2bCustomerAdmin,
    Role.b2bCustomer,
  ]

  static readonly b2bAdminAndPartnerOnly = [
    Role.admin,
    Role.b2bPartner,
    Role.b2bPartnerAdmin,
  ]

  static readonly b2bAdminAndPartnerAndRsmAdmin = [
    Role.admin,
    Role.b2bPartner,
    Role.b2bRsmAdmin,
    Role.b2bPartnerAdmin,
    Role.b2bSvcVendor,
  ]

  static readonly b2bPartner = [
    Role.b2bPartner,
  ]

  static readonly b2bAdmins = [
    Role.admin,
    Role.b2bRsmAdmin,
    Role.b2bPartnerAdmin
  ]

};
